export const QUESTIONS_PER_BLOCK = 50;

export const answerColorMap = {
  false: "red-background",
  true: "green-background",
  null: "",
};
